import { render, staticRenderFns } from "./CallCustomerToday.vue?vue&type=template&id=2a27eef5&scoped=true&"
import script from "./CallCustomerToday.vue?vue&type=script&lang=js&"
export * from "./CallCustomerToday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a27eef5",
  null
  
)

export default component.exports